module.exports = __webpack_public_path__ + "static/media/download1.777788ba.png";